const steps = [1, 2, 3, 4];

let activeStep = 1;
const stepElements = steps.map((step) => {
  const stepContainer = document.getElementById(`step-${step}`)
  return stepContainer;
});

function scrollHandler() {
  stepElements[activeStep - 1].scrollIntoView({behavior: "smooth", inline: "center", block: 'nearest'});
}

const rightArrowContainer = document.getElementById('right-arrow');
const leftArrowContainer = document.getElementById('left-arrow');

if (activeStep === 1) {
  leftArrowContainer.classList.add('disabled');
  document.getElementById('step-1').classList.remove('blur');
} else {
  leftArrowContainer.classList.remove('disabled');
}

function debounce(func, timeout = 300) {
  let timer;
  return(...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function onLeftScrollHandler(handleInstructionSectionScroll) {

  const activeContainerLeft = document.getElementById(`step-${activeStep - 1}`);
  const pastContainerLeft = document.getElementById(`step-${activeStep}`);
  if (activeContainerLeft)
    activeContainerLeft.classList.remove('blur');
  if (pastContainerLeft && activeStep != 1)
    pastContainerLeft.classList.add('blur');

// instructionSection.removeEventListener('scroll', handleInstructionSectionScroll)
  if (activeStep === 1) { // instructionSection.addEventListener('scroll', handleInstructionSectionScroll)
    return;
  } else if (activeStep === 2) {
    activeStep--;
    scrollHandler();
    leftArrowContainer.classList.add('disabled');
  } else {
    activeStep--;
    scrollHandler();
    leftArrowContainer.classList.remove('disabled');
    rightArrowContainer.classList.remove('disabled');
  }

// instructionSection.addEventListener('scroll', handleInstructionSectionScroll)
}function onRightScrollHandler(handleInstructionSectionScroll) {

  const activeContainerRight = document.getElementById(`step-${activeStep + 1}`);
  const pastContainerRight = document.getElementById(`step-${activeStep}`);

  if (activeContainerRight)
    activeContainerRight.classList.remove('blur');
  if (pastContainerRight && activeStep != 4)
    pastContainerRight.classList.add('blur');

// instructionSection.removeEventListener('scroll', handleInstructionSectionScroll)
  if (activeStep === steps.length) { // instructionSection.addEventListener('scroll', handleInstructionSectionScroll)
    return;
  } else if (activeStep === 3) {
    activeStep++;
    scrollHandler();
    rightArrowContainer.classList.add('disabled');
  } else {
    activeStep++;
    scrollHandler();
    leftArrowContainer.classList.remove('disabled');
    rightArrowContainer.classList.remove('disabled');

// instructionSection.addEventListener('scroll', handleInstructionSectionScroll)
  }
}



let scrollX = 0;

const instructionSection = document.querySelector('.instruction-section');

const handleInstructionSectionScroll = () => {
  let timout;

  clearTimeout(timout);

  timeout = setTimeout(() => {
    const {scrollLeft} = instructionSection;

// instructionSection.removeEventListener('scroll', handleInstructionSectionScroll)
    if (scrollLeft > scrollX) {
      onRightScrollHandler(handleInstructionSectionScroll);
      scrollX = scrollLeft;

// instructionSection.addEventListener('scroll', handleInstructionSectionScroll)
    }if (scrollLeft < scrollX) {
      onLeftScrollHandler(handleInstructionSectionScroll);
      scrollX = scrollLeft;

// instructionSection.addEventListener('scroll', handleInstructionSectionScroll)
    }
  }, 400)

};

leftArrowContainer.onclick = onLeftScrollHandler.bind(this, handleInstructionSectionScroll);
rightArrowContainer.onclick = onRightScrollHandler.bind(this, handleInstructionSectionScroll);

// instructionSection.addEventListener('scroll', handleInstructionSectionScroll)

const hoverItemsBlendlab = document.querySelectorAll('.customize-glasses-item .item-hover');
if (hoverItemsBlendlab) {
hoverItemsBlendlab.forEach(item => {
  item.addEventListener('touchstart', (e) => {
    item.classList.add('on-touch');
    item.addEventListener('click', (event) => {
      event.preventDefault();
      window.location.replace(item.getAttribute('href'));
    });
  });
  item.addEventListener('touchend', (e) => {
    item.classList.remove('on-touch');
  })
})
}